module.exports = __webpack_public_path__ + "images/marketing/peeps/jennifer_rideout_redeker.jpg";